import { Chip } from '@telegram-apps/telegram-ui'
import { Heart } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslate } from 'shared/lib/i18n'
import type { FeedChip } from '../lib/state'

function chipKey(c: FeedChip): string {
	return c.kind === 'category' ? `category:${c.id}` : c.kind
}

export function CategoryChips({
	categories,
	active,
	onChange,
}: {
	categories: Array<{ _id: string; name: string }>
	active: FeedChip
	onChange: (chip: FeedChip) => void
}) {
	const { prefixT } = useTranslate('pages.feed')
	const chips: Array<{ chip: FeedChip; label: ReactNode; before?: ReactNode }> = [
		{ chip: { kind: 'all' }, label: prefixT('all') },
		{
			chip: { kind: 'bookmarked' },
			label: prefixT('bookmarked'),
			before: <Heart className="size-4" />,
		},
		...categories.map((c) => ({
			chip: { kind: 'category', id: c._id } as FeedChip,
			label: c.name,
		})),
	]

	return (
		<div className="-mx-4 mt-3.5 flex gap-2 overflow-x-auto px-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
			{chips.map(({ chip, label, before }) => {
				const selected = chipKey(chip) === chipKey(active)
				return (
					<Chip
						key={chipKey(chip)}
						mode="mono"
						before={before}
						onClick={() => onChange(chip)}
						className={
							selected
								? 'shrink-0 cursor-pointer !bg-[var(--tgui--button_color,rgb(41,144,255))] [&_*]:!text-white'
								: 'shrink-0 cursor-pointer'
						}
					>
						{label}
					</Chip>
				)
			})}
		</div>
	)
}
